class FlagData {
  constructor(title, code) {
    this.title = title;
    this.code = code;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allFlagDatas: [],
      allFlagDatasForOther: [],
      flagData: new FlagData('', ''),
      flagDataPaginationList: [],
    };
  },
  methods: {
    getListOfFlagDatasForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllFlagDatas').then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          this.allFlagDatasForOther = this.$store.state.flagDataModule.allFlagDatas;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfFlagDatasForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfFlagDatasForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllFlagDatas: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllFlagDatas').then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          this.allFlagDatas = this.$store.state.flagDataModule.allFlagDatas;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllFlagDatas();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllFlagDatas();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfFlagDatasWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getFlagDatasWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
        })
        .then(() => {
          if (this.$store.state.flagDataModule.successFlag) {
            this.flagDataPaginationList = [];
            let temp = this.$store.state.flagDataModule.flagDatas;
            for (let i = 0; i < temp.length; i++) {
              let isActive = true;
              if (temp[i].isActive === false) {
                isActive = false;
              }
              this.flagDataPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                code: temp[i].code ? temp[i].code : '-',
                id: temp[i].id,
                status: isActive,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.flagDataModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.flagDataModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.flagDataModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.flagDataModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfFlagDatasWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.flagDataModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfFlagDatasWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addFlagDataFunction: function () {
      if (!this.flagData.title) {
        this.snackText = 'عنوان کدهای گوشی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.flagData.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان کدهای گوشی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addFlagData', this.flagData).then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' کدهای گوشی با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.isActive = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.flagData = new FlagData('', '');
          this.getListOfFlagDatasWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getFlagDataFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getFlagData', id).then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          let temp = this.$store.state.flagDataModule.flagData;
          this.flagData.id = temp.id;
          this.flagData.title = temp.title;
          this.flagData.code = temp.code;
          let isActive = true;
          if (this.flagData.isActive === false) {
            isActive = false;
          }
          this.isActive = isActive;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getFlagDataFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getFlagDataFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editFlagDataFunction: function () {
      if (!this.flagData.title) {
        this.snackText = 'عنوان کدهای گوشی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.flagData.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان کدهای گوشی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.flagData.isActive = this.isActive;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editFlagData', this.flagData).then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfFlagDatasWithPagination();
          this.snackText = ' کدهای گوشی با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.isActive = false;
          this.flagData = new FlagData('', '');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteFlagDataFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteFlagData', this.flagDataId).then(() => {
        if (this.$store.state.flagDataModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfFlagDatasWithPagination();
          this.snackText = ' کدهای گوشی با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.flagDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.flagDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteFlagDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.flagDataModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
